/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from "react";
import Screenspy, {
  HangupScreenSpyCall,
} from "./component/Helpers/Lib/screenspy";
let text = "";

export default function TestScreenShare() {
  const [room, setRoom] = useState("");
  const allAttendeeList = [{ user_id: "sdsdse23232", name: "test" }];
  const callDetails = { monitor_status: false };

  const header = () => {
    return (
      <>
        <input
          name="room"
          type="text"
          onChange={(event) => {
            text = event.target.value;
          }}
        />
        <button
          onClick={(event) => {
            event.preventDefault();
            if (text !== "") setRoom(text);
          }}
        >
          Join
        </button>
        <button
          onClick={(event) => {
            event.preventDefault();
            HangupScreenSpyCall();
          }}
        >
          Hangup
        </button>
      </>
    );
  };
  if (room !== "") {
    return (
      <>
        {header()}
        <Screenspy
          room={room}
          user_unique_key="sdsdse23232"
          allAttendeeList={allAttendeeList}
          callDetails={callDetails}
        />
      </>
    );
  } else {
    return (
      <>
        {header()}
        <div></div>
      </>
    );
  }
}
